export default __webpack_public_path__ + "static/media/chatgptMath.f688e238.webp";